__turbopack_context__.v({
  "arrowsWrapper": "SliderSection-module-scss-module__V5sW0G__arrowsWrapper",
  "container": "SliderSection-module-scss-module__V5sW0G__container",
  "overlayLeft": "SliderSection-module-scss-module__V5sW0G__overlayLeft",
  "overlayRight": "SliderSection-module-scss-module__V5sW0G__overlayRight",
  "root": "SliderSection-module-scss-module__V5sW0G__root",
  "sliderWrapper": "SliderSection-module-scss-module__V5sW0G__sliderWrapper",
});
